import { RoutineOrderComponent } from './RoutineOrderComponent';

export default RoutineOrderComponent;
